import Chip from './Chip';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectBreadcrumbsFromPath } from 'services/api/resources/selectors';
import { useAppSelector } from 'services/store';

interface Props {
  categoryPath: string;
}

export default function ResourceChipCrumbs({ categoryPath }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  const breadcrumbs = useAppSelector(state =>
    selectBreadcrumbsFromPath(state, categoryPath),
  );

  if (!breadcrumbs.length) {
    return null;
  }

  return (
    <>
      {breadcrumbs.map((category, index) => {
        const parentPathSlugs = breadcrumbs.slice(0, index).map(c => c.slug);

        const toPath =
          parentPathSlugs.length > 0
            ? `/resources/${parentPathSlugs.join('/')}`
            : `/resources`;

        return (
          <Chip
            key={category.id}
            label={category.name}
            onClick={() =>
              navigate(`${toPath}${location.search}`, { replace: true })
            }
          />
        );
      })}
    </>
  );
}
